export default "__VITE_ASSET__3b5840bb__"